import { DefaultButton } from "@fluentui/react";
import * as React from "react";
export const SignInButton = ({ login }) => {
    return (React.createElement(DefaultButton, { className: "mecontrolSigninButton", text: "Sign In", onClick: login, styles: {
            rootHovered: { backgroundColor: "#393939", color: "#fff" },
            rootFocused: { backgroundColor: "#393939", color: "#fff" },
            rootPressed: { backgroundColor: "#393939", color: "#fff" },
        } }));
};
